import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref } from 'vue';
import NModel from '@/component/NModel/NModel.vue';
import { message } from 'ant-design-vue';
import DiscountForm from './DiscountForm.vue';
import GoodsTable from './GoodsTable.vue';
import { addDiscount } from '@/api/marketing/discount';
import moment from 'moment';
import EditableCell from '@/component/editable-cell.vue';
import { useRouter } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDiscount',
  setup(__props) {

const selectedRowKeys = ref<any[]>([]); // 选中
const isAllSelected = ref<boolean>(false); // 全选
const isFirst = ref<boolean>(true); // 第一步
const dataSource = ref<any[]>([]); // 表格
const DiscountFormRef = ref<any>(null);
const formVal = ref<any>(); // 表单信息
const visible = ref<any>(false); // 添加商品弹窗
const delVisible = ref<any>(false); // 批量删除弹窗
const goods_data = ref<any>();
const goods_id = ref<any>();
const router = useRouter();
const page = ref(1);
const pageSize = ref(10);
const total = computed(() => dataSource.value?.length);
const currentData = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return dataSource.value?.slice(start, end);
});
/**
 * 步骤一
 */
function next() {
  DiscountFormRef.value.getFormData();
  if (formVal.value) {
    isFirst.value = !isFirst.value;
    isFirst.value == true && (formVal.value = null);
  }
}
// 获取form表单信息
function getVal(val) {
  formVal.value = val;
}
function getGoodData(val) {
  dataSource.value = [...dataSource.value, ...val];
  message.success('添加成功');
  visible.value = false;
}
function getGoodIds(val) {
  goods_id.value = val;
}

/**
 * 步骤二
 */
// 添加货品
function addWare() {
  visible.value = true;
}
// 编辑排序值
async function handleSortChange(index: number, sort: number) {
  if (!/^[0-9]+$/.test(sort + '')) {
    message.error('排序值须为>0的整数值！');
    return;
  }
  if (!(dataSource.value[index] as any).is_new) {
    (dataSource.value[index] as any).is_edit = true;
    (dataSource.value[index] as any).sort = sort;
  } else {
    (dataSource.value[index] as any).sort = sort;
  }
}

// 添加商品-弹窗
async function addGoods() {
  dataSource.value = goods_data.value;
  visible.value = false;
}
//
function onSelectChange(selectedRow) {
  selectedRowKeys.value = selectedRow;
  if (selectedRowKeys.value.length == dataSource.value.length) {
    isAllSelected.value = true;
  } else {
    isAllSelected.value = false;
  }
}
// 全选框
function onSelectAllRows(e) {
  isAllSelected.value = e.target.checked;
  if (isAllSelected.value) {
    selectedRowKeys.value = dataSource.value?.map(item => item.id);
  } else {
    selectedRowKeys.value = [];
  }
}
// 批量操作-删除
function handleMenuClick(e) {
  if (selectedRowKeys.value.length > 0) {
    delVisible.value = true;
  } else {
    delVisible.value = false;
  }
}
// 删除确认
function delConfirm() {
  dataSource.value = dataSource.value.filter(item => !selectedRowKeys.value.includes(item.id));
  selectedRowKeys.value = []; // 清空选中的键值数组
  delVisible.value = false;
  goods_data.value = dataSource.value;
  isAllSelected.value = false;
}
// 删除取消
function delCancel() {
  delVisible.value = false;
}
// 删除
function deleteProduct(id) {
  dataSource.value = dataSource.value.filter(item => item.id !== id);
  goods_data.value = dataSource.value;
}
async function confirm() {
  const product_list = dataSource.value.map(({ id, sort }) => ({ id, sort }));
  const send_data = {
    name: formVal.value.name,
    type: formVal.value.type,
    superposition: formVal.value.overlay,
    threshold_price: formVal.value.threshold_price,
    discounts_minus: formVal.value.type == 1 ? formVal.value.discounts_minus : '',
    discounts_ratio: formVal.value.type == 2 ? formVal.value.discounts_ratio : '',
    start_time: formVal.value.start_time,
    end_time: formVal.value.end_time,
    product_list,
  };
  const res = await addDiscount(send_data);
  if (res.status !== 200) {
    message.error((res as any).message);
    return;
  }
  message.success('新建成功');
  router.push('/marketing/discount');
}
function Format(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}
// 点击返回按钮
function onGoBack() {
  router.push('/marketing/discount');
}
onMounted(() => {
  dataSource.value = dataSource.value?.slice(0, pageSize.value);
});

return { __sfc: true,selectedRowKeys, isAllSelected, isFirst, dataSource, DiscountFormRef, formVal, visible, delVisible, goods_data, goods_id, router, page, pageSize, total, currentData, next, getVal, getGoodData, getGoodIds, addWare, handleSortChange, addGoods, onSelectChange, onSelectAllRows, handleMenuClick, delConfirm, delCancel, deleteProduct, confirm, Format, onGoBack, NModel, DiscountForm, GoodsTable, EditableCell }
}

})